import { connect } from 'react-redux';
import { AUTH_LEVELS } from './Authorized';

/**
 * Component to limit ui-elements to org or super admins
 */
const Admin = ({ children, isAuthorized }) => (isAuthorized ? children : null);

export default connect(({ user: { userAuthLevel } }, { superAdmin = false }) => ({
  isAuthorized: userAuthLevel <= (superAdmin ? AUTH_LEVELS.SUPER_ADMIN : AUTH_LEVELS.ORG_ADMIN),
}))(Admin);
